import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { getMenusByUser } from '../../../config/services/menus';
import {
  addPermission,
  deletePermissionsByUser
} from '../../../config/services/permissions';
import CustomButton from '../../components/CustomButton';
import useLoading from '../../../hooks/useLoading';

import ItemMenu from './components/ItemMenu';

function UserPermissions() {
  const {
    state: { userId, userName }
  } = useLocation();
  const [menus, setMenus] = useState();
  const [loading, setLoading] = useState(false);
  const [updatingPermissions, setUpdatingPermissions] = useState(false);

  useLoading(loading || updatingPermissions);

  const getUserMenus = useCallback(async () => {
    setLoading(true);
    const response = await getMenusByUser(userId);
    if (response.ok) {
      const [allMenus, permissions] = response.data;
      const mappedMenus = allMenus.map(item => {
        const permission = permissions.find(
          permission => permission.menu === item.id
        );
        return {
          ...item,
          checked: permissions.some(
            permission => permission.menu.toString() === item.id.toString()
          ),
          permission: permission?.['permission'],
          permissionId: permission?.['id']
        };
      });
      setMenus(mappedMenus);
      setLoading(false);
    }
    setLoading(false);
  }, [userId]);

  useEffect(() => {
    getUserMenus();
  }, [getUserMenus]);

  const handlePressCheck = menuId => {
    const newMenus = menus.map(menu => {
      if (menu.id === menuId) {
        return { ...menu, checked: !menu.checked };
      }
      return menu;
    });
    setMenus(newMenus);
  };

  const handleChangePermission = (menuId, permissionValue) => {
    const newMenus = menus.map(menu => {
      if (menu.id === menuId) {
        return { ...menu, permission: permissionValue };
      }
      return menu;
    });
    setMenus([...newMenus]);
  };

  const handlePressSave = async () => {
    setUpdatingPermissions(true);
    await deletePermissionsByUser(userId);
    await Promise.all(
      menus.map(menu => {
        if (menu.checked) {
          const permissionData = {
            user: userId,
            menu: menu.id,
            permission: menu.permission || 'VIEW'
          };
          return addPermission(permissionData);
        }
        return Promise.resolve();
      })
    );
    setUpdatingPermissions(false);
  };

  return (
    <div>
      <h2>Permisos de Usuario</h2>
      <h3>{userName}</h3>
      <div>
        {menus?.map(menu => (
          <ItemMenu
            key={menu.id}
            menu={menu}
            handlePressCheck={handlePressCheck}
            handleChangePermission={handleChangePermission}
          />
        ))}
      </div>
      <CustomButton type={'button'} onClick={handlePressSave}>
        Guardar
      </CustomButton>
    </div>
  );
}

export default UserPermissions;
